import { type SiteLinkUrl } from '@/true-fsd/data/link'
import { linkMethods } from '@synapex/shared2/entities'
import { coerceUrlOrThrow, zUrl } from '@synapex/tools/utils'

import { makeReducer, useParsedInput } from '../parsedInput'
import { useCallback, useState } from 'react'

type Ctx = {
    erid?: string
}

const schema = zUrl({
    nonEmpty: 'Введите URL',
    url: 'Неправильный URL',
})

type ParsedValue = Pick<SiteLinkUrl, 'hostname' | 'pathname'>

const shortUrlReducer = makeReducer<ParsedValue, Ctx>({
    parse: (_, input) => {
        return linkMethods.siteLinkUrlFromUrl(schema.parse(input))
    },
    stringify: ({ erid }, parsedValue) => {
        const url = coerceUrlOrThrow(
            `${parsedValue.hostname}/${parsedValue.pathname}`
        )

        if (erid) {
            url.searchParams.append('erid', erid)
        }

        return url.href
    },
})

export const useShortUrlInput = (
    ctx: Ctx,
    initialParsedValue: ParsedValue | null
) => {
    const [inputEnabled, setInputEnabled] = useState(false)

    const { onChangeParsedValue, parsedValue, onNormalize, ...pi } =
        useParsedInput({
            ...shortUrlReducer,
            ctx,
            initialParsedValue,
        })

    const onCancel = useCallback(() => setInputEnabled(false), [])
    const onApply = useCallback(() => {
        setInputEnabled(false)
        onNormalize()
    }, [onNormalize])
    const onInput = useCallback(() => setInputEnabled(true), [])

    const onClear = useCallback(
        () => onChangeParsedValue(null),
        [onChangeParsedValue]
    )

    return {
        ...pi,
        parsedValue,
        inputEnabled,
        onCancel,
        onApply,
        onClear,
        onInput,
    }
}
export type UseShortUrlInput = ReturnType<typeof useShortUrlInput>
